import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

import { Collapse, OverlayTrigger, Popover, Button, MenuItem, Tooltip, Modal } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { 
  each, tail, filter as lodashFilter, 
  indexOf, map, without, find, uniq,
  intersection, isArray, delay, reduce,
  debounce,
} from 'lodash';
import ReactResizeDetector from 'react-resize-detector';

import CustomHeader from '../../../../components/god-table/header';
import FilterButton from '../../components/FilterButton/FilterButton';
import FilterMappingButton from '../../components/FilterMappingButton/FilterMappingButton';
import ProgressBar from '../../../../components/progress-bar';
import SearchField from '../../../../components/search-field';
import MappingSearchForm from '../../components/SearchForm/SearchForm';
// Import Actions
import { fetchFilter, fetchFilterOptions, updateMappingValues, upmapMappingValues } from '../../FilterActions';
import { syncActiveOwners } from '../../SetupActions';
import ImportMappingModal from '../../components/import-mapping-modal';

// Import Selectors
import { getFilter, getFilters, getMappingOptions, getSearchableFields } from '../../FilterReducer';
import { getViewableDimensions } from '../../../App/AppReducer';
import LabelCellRenderer from './LabelCellRenderer';
import MappingToggleCellRenderer from './MappingToggle';
import ExcludeToggleCellRenderer from './ExcludeToggle';
import styles from './styles.css';


const mappingColumnWidth = 100;

const initState = {
  query: null,
  loading: true,
  errors: null,
  truncated: true,
  selectedMappingIds: [],
  showingPopover: false,
  id: null,
  updating: false,
  updatingRowId: null,
  updatingColId: null,
  filters: {},
  showAddModal: false,
  navBarHeight: 0,
  mapping: null,
  openMappingModal: false,
  colDefs: [],
  options: [],
  isUserMapping: false,
  isPaginated: false,
  totalRows: null,
  showSyncModal: false,
  openImportModal: false,
  currentMapping: null,
};

class FilterDetailPage extends Component {
  constructor(args) {
    super(args);
    this.state = { ...initState };
    this.syncFilter = this.syncFilter.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleQuickNav = this.handleQuickNav.bind(this);
    this.toggleValue = this.toggleValue.bind(this);
    this.excludeValue = this.excludeValue.bind(this);
    this.showAddModal = this.showAddModal.bind(this);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchDebounce = debounce(this.handleSearch, 500);

    this.onResizeNavBar = this.onResizeNavBar.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.getMainMenuItems = this.getMainMenuItems.bind(this);
    this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
    this.requestAddMapping = this.requestAddMapping.bind(this);
    this.requestEditMapping = this.requestEditMapping.bind(this);
    this.valueMappingGetter = this.valueMappingGetter.bind(this);
    this.getMappingCellRendererSelector = this.getMappingCellRendererSelector.bind(this);
    this.getExcludeCellRendererSelector = this.getExcludeCellRendererSelector.bind(this);
    this.handleOnMappingDeleted = this.handleOnMappingDeleted.bind(this);
    this.handleOnMappingUpdated = this.handleOnMappingUpdated.bind(this);
    this.getContextMenuItems = this.getContextMenuItems.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.excludedValueMappingGetter = this.excludedValueMappingGetter.bind(this);
    this.getRows = this.getRows.bind(this);
    this.showSyncActiveOwnerInstructions = this.showSyncActiveOwnerInstructions.bind(this);
    this.hideSyncActiveOwnerInstructions = this.hideSyncActiveOwnerInstructions.bind(this);
    this.requestSync = this.requestSync.bind(this);
    this.requestShowImportModal = this.requestShowImportModal.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.handleFilterUpdate = this.handleFilterUpdate.bind(this);
  }

  componentWillMount() {
    this.state = { ...initState };
    // fire action to update redux project store
    this.syncFilter();
  }

  componentDidUpdate(prevProps) {
    if (prevProps === undefined) {
      return;
    }
    if (this.state.id !== this.props.match.params.filterID) {
      this.syncFilter();
    }
  }

  showSyncActiveOwnerInstructions() {
    this.setState({ showSyncModal: true });
  }

  hideSyncActiveOwnerInstructions() {
    this.setState({ showSyncModal: false });
  }

  handleFilterUpdate(f) {
    this.loadOptions(f)
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.state.isPaginated) {
      const createDatasource = () => ({
        // called by the grid when more rows are required
        getRows: this.getRows,
      });
      const myDatasource = createDatasource();
      params.api.setServerSideDatasource(myDatasource);
    }
  }

  onFirstDataRendered() {
    if (this.gridApi && this.gridColumnApi) {
      this.gridApi.showLoadingOverlay();
      delay(() => {
        const { viewableDimensions } = this.props;
        const allColumns = this.gridColumnApi.getColumns();
        const allColumnIds = map(allColumns, 'colId');
        this.gridColumnApi.autoSizeColumns(allColumnIds);
        let allWidths = 0;
        each(this.gridColumnApi.getColumns(), (col) => {
          allWidths += col.actualWidth;
        });
        const viewableWidth = viewableDimensions.width;
        if (allWidths < viewableWidth - 2) {
          this.gridApi.sizeColumnsToFit();
        }
        this.gridApi.hideOverlay();
      }, 1000);
    }
  }

  requestSync() {
    this.props.dispatch(syncActiveOwners());
  }

  onResizeNavBar(width, navBarHeight) {
    this.setState({ navBarHeight });
  }

  getContextMenuItems(/* params */) {
    const results = [
      'copy',
      'copyWithHeaders',
    ];
    return results;
  }

  getRows(params) {
    const { match: { params: { filterID } } } = this.props;
    
    const { request } = params;


    const query = {
      ...(this.state.query && this.state.query.length > 0 ? { q: this.state.query } : {}),
      startRow: request ? request.startRow : 0,
      endRow: request ? request.endRow : null,
    };
    if (request && request.sortModel && request.sortModel[0]) {
      query.sortOrder = request.sortModel[0].colId;
      query.sortDir = request.sortModel[0].sort;
    }

    this.props.dispatch(fetchFilterOptions(filterID, query))
      .then(
        (res) => {
          if (res.isPaginated) {
            let currentQuery = this.state.query;
            if (!currentQuery || currentQuery === '') {
              currentQuery = null;
            }
            let requestQuery = res.query;
            if (!requestQuery || requestQuery === '') {
              requestQuery = null;
            }
            if (requestQuery === currentQuery) {
              this.setState({
                isUserMapping: res.isUser,
                isPaginated: true,
                totalRows: res.total !== null && res.total !== undefined ? res.total : this.state.totalRows,
              }, () => {
                params.success({ rowData: res.options });
              });
            }
          } else {
            this.setState({
              isUserMapping: res.isUser,
              totalRows: null,
              isPaginated: false,
            }, () => {
              params.success({ rowData: res.options });
            });
          }
        },
        (errors) => {
          params.fail(errors);
        },
      );
  }

  getMainMenuItems(params) {
    const { column: { colDef: { cellRendererParams } } } = params;
    let menuItems = params.defaultItems;
    if (cellRendererParams.canEditMapping) {
      menuItems = params.defaultItems.slice(0);
      menuItems.push({
        name: 'Edit Filter Group',
        icon: '<i class="fa fa-edit"></i>',
        action: () => {
          this.requestEditMapping(cellRendererParams.column);
        },
      });

      menuItems.push({
        name: 'Import Mapping Values',
        icon: '<i class="fa fa-upload"></i>',
        action: () => {
          this.requestShowImportModal(cellRendererParams.column);
        },
      });

    }
    return without(menuItems, 'resetColumns', 'pinSubMenu');
  }

  getMappingCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: MappingToggleCellRenderer,
      params: {
        onToggleValue: this.toggleValue,
      },
    };
  }

  getExcludeCellRendererSelector(params) {
    if (!params) {
      return null;
    }
    return {
      component: ExcludeToggleCellRenderer,
      params: {
        onToggleValue: this.excludeValue,
      },
    };
  }


  getColumnDefs(filter) {
    const { mappingOptions } = this.props;
    const canEditMapping = filter.$can_edit_mapping;
    let mainColumnName = filter.target_field === 'Id' ? filter.target_object : filter.target_field;
    if (!mainColumnName) {
      mainColumnName = filter.label;
    }
    /*
    if (filter.target_field === 'profile_id') {
      mainColumnName = 'User Profile';
    } else if (filter.target_field === 'user_role_id' || filter.target_field === 'UserRoleId') {
      mainColumnName = 'User Role';
    } else if (filter.target_field === 'opportunity_role') {
      mainColumnName = 'Contact Role';
    }
    */
    
    const isRadio = filter.type === 'picklist';
    const totalMappings = filter && filter.mappings ? filter.mappings.length : 0;
    const renderExcludeColumn = totalMappings > 1;
    const isDealType = filter.tag === 'dealType';
    let showGroups = false;
    if (isDealType) {
      showGroups = uniq(map(mappingOptions, 'family')).length > 1;
    }
    const columnDefs = [
      {
        headerName: mainColumnName,
        field: 'label',
        pinned: 'left',
        colId: 'LABEL',
        suppressMenu: true,
        cellRenderer: LabelCellRenderer,
        suppressMovable: true,
        suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
        // minWidth: mainColumnWidth,
        cellRendererParams: {
          isUserMapping: this.state.isUserMapping,
        },
      },
      ...(filter.mappings.map(m => ({
        headerName: m.label,
        colId: m._id,
        suppressMovable: true,
        // field: 'value', // TODO: get value! is checked? so that it can be sorted
        minWidth: mappingColumnWidth,
        valueGetter: this.valueMappingGetter,
        cellRendererSelector: this.getMappingCellRendererSelector,
        cellRendererParams: {
          column: m,
          canEditMapping,
          isRadio,
        },
      }))),
      ...(renderExcludeColumn ? [
        {
          headerName: 'Exclude',
          colId: 'EXCLUDE',
          // field: 'excluded', // invert of this!
          suppressMenu: true,
          suppressMovable: true,
          suppressColumnsToolPanel: true,
        suppressFiltersToolPanel: true,
          minWidth: mappingColumnWidth,
          valueGetter: this.excludedValueMappingGetter,
          cellRendererSelector: this.getExcludeCellRendererSelector,
          cellRendererParams: {
            canEditMapping,
          },
          pinned: 'right',
        },
      ] : []),
      ...(showGroups ? [
        {
          headerName: 'Family',
          colId: 'FAMILY',
          field: 'family', // invert of this!
          suppressMenu: true,
          suppressMovable: true,
          hide: true,
          enablePivot: false,
          enableRowGroup: false,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
          rowGroup: true,
          rowGroupIndex: 0,
          valueGetter: (params) => {
            if (!params.data) {
              return null;
            }
            if (params.data && params.data.family === 'Record Type ID') {
              return 'Record Type';
            }
            return params.data.family;
          },
        },
      ] : []),
    ];
    return columnDefs;
  }

  loadOptions(filter) {
    // const { match: { params: { filterID } } } = this.props;
    const p = new Promise((resolve, reject) => {
      this.props.dispatch(fetchFilterOptions(filter._id))
        .then(
          (res) => {
            if (res.isPaginated) {
              this.setState({
                isPaginated: res.isPaginated,
                isUserMapping: res.isUser,
                totalRows: res.total,
              });
            } else {
              this.setState({
                isPaginated: res.isPaginated,
                isUserMapping: res.isUser,
                totalRows: null,
              });
            }
            resolve(res.options);
          },
          () => {
            resolve([]);
          },
        );
    });
    p.then(
      (opts) => {
        const colDefs = this.getColumnDefs(filter);
        this.setState({ loading: false, errors: null, colDefs, options: opts }, () => {
          this.onFirstDataRendered();
        });
      },
    );
    return p;
  }

  syncFilter() {
    const { match: { params: { filterID } } } = this.props;
    this.setState({
      id: this.props.match.params.filterID,
      loading: true,
      errors: null,
      selectedMappingIds: [],
      filters: {},
      query: null,
      options: [],
    });
    this.props.dispatch(fetchFilter(filterID))
      .then(
        ({ filter }) => {
          this.loadOptions(filter);
          /*
          const pOptions = this.loadOptions(filter);
          pOptions.then(
            (opts) => {
              const colDefs = this.getColumnDefs(filter);
              this.setState({ loading: false, errors: null, colDefs, options: opts }, () => {
                this.onFirstDataRendered();
              });
            },
          );
          */
        },
        (error) => {
          this.setState({ loading: false, errors: error.data || error });
        },
      );
  }

  requestAddMapping() {
    this.setState({ mapping: {}, openMappingModal: true });
  }

  requestEditMapping(mapping) {
    this.setState({ mapping, openMappingModal: true });
  }

  requestShowImportModal(currentMapping) {
    this.setState({ openImportModal: true, currentMapping });
  }

  handleImport(keywords) {
    const p = this.submitValues(this.state.currentMapping, keywords, true);
    p.then(
      () => {
        this.refreshCells();
      },
    );
    return p;
  }

  handleSearch(query) {
    if (this.gridApi) {
      this.setState({ query }, () => {
        if (this.state.isPaginated) {
          this.gridApi.refreshServerSideStore();
        } else {
          this.gridApi.setQuickFilter(query);
        }
      });
    }
  }

  handleDownload() {
    if (this.gridApi) {
      const { filter } = this.props;
      const params = {
        columnGroups: true,
        fileName: `${filter.label} - TruSales`,
        sheetName: `${filter.label}`,
        exportMode: 'xlsx',
      };
      this.gridApi.exportDataAsExcel(params);
    }
  }

  handleOnMappingDeleted() {
    this.updateMappingInfo();
  }

  handleOnMappingUpdated() {
    this.updateMappingInfo();
  }

  updateMappingInfo() {
    const { filter } = this.props;
    if (this.gridApi) {
      const newColDefs = this.getColumnDefs(filter);
      each(newColDefs, (colDef) => {
        const { colId } = colDef;
        if (colId !== 'LABEL' && colId !== 'EXCLUDE') {
          colDef.minWidth = mappingColumnWidth;
        }
      });
      this.setState({ colDefs: newColDefs }, () => {
        delay(() => {
          this.gridApi.redrawRows({ force: true });
          this.gridApi.sizeColumnsToFit();
        }, 100);
      });
    }
  }
  
  handleDelete() {
    this.context.router.history.push('/setup/filters');
  }

  handleQuickNav(id) {
    this.context.router.history.push(`/setup/filters/${id}`);
  }

  refreshCells() {
    if (this.gridApi) {
      const params = { force: true };
      this.gridApi.refreshCells(params);
    }
  }

  flashRow(rowId) {
    if (this.gridApi) {
      const node = this.gridApi.getRowNode(rowId);
      if (node) {
        this.gridApi.flashCells({ rowNodes: [node] });
      }
    }
  }

  submitValues(mapping, values, append = false) {
    const { filter } = this.props;
    return new Promise((resolve, reject) => {
      this.props.dispatch(updateMappingValues(filter._id, mapping._id, { values }, append))
        .then(
          ({ reports }) => {
            resolve(reports);
          },
          (e) => {
            reject(e)
          },
        );
    });
  }

  toggleValue(mapping, value) {
    if (this.state.updatingRowId || this.state.updatingColId) {
      return;
    }
    // const validOptions = map(this.props.mappingOptions, 'value');
    
    
    const values = mapping.values || [];
    const active = indexOf(values, value) >= 0;
    const newValues = active ? without(values, value) : [...values].concat([value]);

    this.submitValues(mapping, newValues, false)
      .then(
        () => {
          this.setState({ updatingRowId: null, updatingColId: null }, () => {
            this.refreshCells();
            this.flashRow(value);
          });
        },
        () => {
          this.setState({ updatingRowId: null, updatingColId: null }, () => {
            this.refreshCells();
          });
        },
      );
  }

  excludeValue(value) {
    if (this.state.updatingRowId || this.state.updatingColId) {
      return;
    }
    const { filter } = this.props;
    this.setState({ updatingRowId: value, updatingColId: null }, () => {
      this.refreshCells();
      this.props.dispatch(upmapMappingValues(filter._id, { values: [value] }))
        .then(
          () => {
            this.setState({ updatingRowId: null, updatingColId: null }, () => {
              this.flashRow(value);
              this.refreshCells();
            });
          },
          () => {
            this.setState({ updatingRowId: null, updatingColId: null });
          },
        );
    });
  }

  showAddModal() {
    this.setState({ showAddModal: true });
  }

  valueMappingGetter(params) {
    if (!params.data) {
      return null;
    }
    const { data, colDef: { colId } } = params;
    const { filter } = this.props;
    const mapping = find(filter.mappings, { _id: colId });
    if (!mapping) {
      return false;
    }
    const values = mapping.values || [];
    return indexOf(values, data.value) >= 0;
  }

  excludedValueMappingGetter(params) {
    const { data } = params;
    if (!data) {
      return null;
    }
    const { filter } = this.props;
    const mappings = filter.mappings || [];
    const { value } = data;
    const v = reduce(mappings, (itm, mapping) => {
      const indx = indexOf(mapping.values, value);
      if (indx >= 0) {
        return true;
      }
      return itm || false;
    }, false);
    return !v;
  }

  renderDescription() {
    const { truncated } = this.state;
    const { filter } = this.props;
    const { description } = filter;
    if (!description || description.length === 0) {
      return null;
    }
    const pieces = description.split('\n');
    if (pieces.length === 1) {
      return (
        <div className="well well-sm">
          <ReactMarkdown source={description} />
        </div>
      );
    }
    const firstDescription = pieces[0];
    const restDescription = tail(pieces).join('\n');
    return (
      <div className="well well-sm">
        <div>
          <ReactMarkdown source={firstDescription} />
        </div>
        <Collapse in={!truncated}>
          <ReactMarkdown source={restDescription} />
        </Collapse>
        <div className="text-left">
          <a className="btn btn-link btn-xs" href="" onClick={(e) => { e.preventDefault(); this.setState({ truncated: !truncated }); }}>
            {truncated && <span>read more <Fa name="angle-double-down" /></span>}
            {!truncated && <span>read less <Fa name="angle-double-up" /></span>}
          </a>
        </div>
      </div>
    );
  }

  renderDownloadButton() {
    if (!this.gridApi) {
      return null;
    }
    return (
      <OverlayTrigger placement="top" overlay={<Tooltip id="custom-field-download-tip">Export as Excel File</Tooltip>}>
        <Button bsStyle="link" onClick={this.handleDownload}>
          <Fa name="download" />
        </Button>
      </OverlayTrigger>
    );
  }
  
  renderTable() {
    const {
      updatingRowId, updatingColId, filters,
      navBarHeight, colDefs, options,
      isPaginated,
    } = this.state;
    const {
      filter, viewableDimensions, searchableFields,
    } = this.props;
    const updating = updatingRowId !== null || updatingColId !== null;
    const canAddMapping = filter.$can_add_mapping;
    const canEditMapping = filter.$can_edit_mapping;
    const mappingOptions = options;
    let items = mappingOptions || [];

    const mappingFilter = filters.mappings && filters.mappings !== '' ? filters.mappings : null;
    const searchableFilters = filters.searchable ? filters.searchable : null;
    
    items = lodashFilter(items, (field) => {
      let matchMapping = true;
      let searchableMatch = true;
      
      if (mappingFilter) {
        matchMapping = field.mapped === (mappingFilter === 'assigned');
      }
      if (searchableFilters) {
        searchableMatch = true;
        if (field.searchable) {
          each(filters.searchable, (vals, name) => {
            if (vals.length) {
              let userVals = field.searchable[name];
              if (!isArray(userVals)) {
                userVals = [userVals];
              }
              searchableMatch = searchableMatch && intersection(userVals, vals).length > 0;
            }
          });
        }
      }
      return matchMapping && searchableMatch;
    });


    const totalMappings = filter && filter.mappings ? filter.mappings.length : 0;
    const viewableHeight = viewableDimensions.height - navBarHeight;
    const cls = ['ag-theme-alpine'];
    const domLayout = 'normal';
    let showAdvancedSearch = false;
    const stl = {
      width: '100%',
      height: viewableHeight,
    };

    if (filter.type === 'multipicklist' || filter.type === 'picklist') {
      if (filter.mappings && filter.mappings.length > 0) {
        showAdvancedSearch = true;
      } else if (searchableFields.length > 0) {
        showAdvancedSearch = true;
      }
    }

    if (isPaginated) {
      showAdvancedSearch = false;
    }

    const paginationProps = {
      getRowNodeId: (data) => data._id,
    };
    if (isPaginated) {
      paginationProps.pagination = true;
      paginationProps.paginationAutoPageSize = true;
      paginationProps.rowModelType = 'serverSide';
      paginationProps.deltaRowDataMode = true;
      // paginationProps.rowData = [];
    } else {
      paginationProps.rowData = items;
      paginationProps.rowModelType = 'clientSide';
    }

    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <div className="navbar-form navbar-right">
            {items.length > 0 && canAddMapping &&
              <Button disabled={updating} onClick={this.requestAddMapping} bsStyle="primary">
                <Fa name="plus" /> Add New Group
              </Button>
            }
            {this.renderDownloadButton()}
            &nbsp;&nbsp;
          </div>
          <form className="navbar-form navbar-left">
            <SearchField collapsible={false} onSearch={isPaginated ? this.handleSearchDebounce : this.handleSearch} />
            {mappingOptions.length > 0 && showAdvancedSearch &&
              <MappingSearchForm
                filters={(filter.target_field === 'Id' || filter.$is_user_mapping) ? searchableFields : []}
                title="Advanced Search"
                showMapping
                onApply={(newFilters) => { this.setState({ filters: newFilters }); }}
              />
            }
          </form>
          <ReactResizeDetector handleHeight onResize={this.onResizeNavBar} />
        </nav>
        <div className={cls.join(' ')} style={stl}>
          <AgGridReact
            reactNext
            enableColResize
            enableSorting
            animateRows
            columnDefs={colDefs}
            getRowNodeId={data => data.value}
            onGridReady={this.onGridReady}
            domLayout={domLayout}
            suppressColumnVirtualisation
            groupUseEntireRow
            groupDefaultExpanded={-1}
            context={{ 
              mappings: filter.mappings,
              updatingRowId,
              updatingColId,
            }}
            sideBar={totalMappings > 4 ? {
              toolPanels: [
                {
                  id: 'columns',
                  labelDefault: 'Columns',
                  labelKey: 'columns',
                  iconKey: 'columns',
                  toolPanel: 'agColumnsToolPanel',
                  toolPanelParams: {
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnFilter: true,
                    suppressColumnSelectAll: true,
                    suppressColumnExpandAll: true,
                    suppressRowGroups: true,
                    suppressValues: true,
                  },
                },
              ],
            } : null}
            components={{
              agColumnHeader: CustomHeader,
            }}
            defaultColDef={{
              resizable: true,
              sortable: true,
            }}
            getMainMenuItems={this.getMainMenuItems}
            getContextMenuItems={this.getContextMenuItems}
            {...paginationProps}
          />
        </div>
        {(canAddMapping || canEditMapping) && 
          <FilterMappingButton
            filter={filter} 
            mapping={this.state.mapping}
            open={this.state.openMappingModal}
            onClose={() => { this.setState({ mapping: null, openMappingModal: false }); }}
            onDelete={this.handleOnMappingDeleted}
            onSuccess={this.handleOnMappingUpdated}
          />
        }
      </div>
    );
  }

  renderQuickNav() {
    const { showAddModal } = this.state;
    const { filter, filters } = this.props;
    const items = lodashFilter(filters, f => (f.type === 'picklist' || f.type === 'multipicklist') && !f.is_boolean && !f.$is_opportunity_id);
    if (items.length === 0) {
      return (<span>{filter.label}</span>);
    }
    const popover = (
      <Popover id="popover-quick-nav" className={styles.dropdownPopover}>
        <ul className={`dropdown-menu open ${styles.dropdown}`}>
          {items.map((f) => {
            const active = f._id === filter._id;
            return (
              <MenuItem onSelect={this.handleQuickNav} active={active} key={f._id} eventKey={f.is_system_filter ? f.tag : f._id}>
                <Fa name="star" className={f.is_system_filter ? 'text-warning' : 'invisible'} />
                <span>&nbsp;{f.label}</span>
              </MenuItem>
            );
          })}
          {items.length > 0 && <MenuItem divider />}
          <MenuItem onSelect={this.showAddModal}>
            <Fa name="plus" /> Add new filter
          </MenuItem>
        </ul>
      </Popover>
    );
    return (
      <span>
        <FilterButton
          isButton={false}
          filter={{}}
          onClose={() => { this.setState({ showAddModal: false }); }}
          open={showAddModal}
          onCreate={(newFilter) => {
            if (newFilter.type === 'picklist' || newFilter.type === 'multipicklist') {
              this.handleQuickNav(newFilter._id);
            }
          }}
          onUpdate={this.handleFilterUpdate}
        />
        <OverlayTrigger
          trigger="click"
          rootClose
          placement="bottom"
          overlay={popover}
        >
          <span style={{ cursor: 'pointer' }}>{filter.label} <Fa name="caret-down" className="text-muted" /></span>
        </OverlayTrigger>
      </span>
    );
  }

  renderSyncModal() {
    const { showSyncModal } = this.state;
    return (
       <Modal key="modal" show={showSyncModal} onHide={this.hideSyncActiveOwnerInstructions}>
        <Modal.Header closeButton>
          <h4>Sync All Active Sales Reps</h4>
        </Modal.Header>
        <Modal.Body>
          This will sync all active sales reps from CRM.
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            <Button className="pull-right" onClick={this.requestSync} bsStyle="primary">Sync</Button>
            <Button className="pull-left" bsStyle="default" onClick={this.hideSyncActiveOwnerInstructions}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { filter } = this.props;
    const { loading, errors, isUserMapping, openImportModal } = this.state;
    if (!filter || !filter._id) {
      return null;
    }
    return (
      <div>
        <Helmet title="Manage Filters" />
        <div className="row">
          <div className="col-xs-6">
            <h2 className="page-sub-header">
              <Link to="/setup/filters">All Filters</Link>
              <span>&nbsp;<Fa name="angle-right" className="text-muted" />&nbsp;</span>
              {this.renderQuickNav()}
            </h2>
          </div>
          <div className="col-xs-6">
            <div className="pull-right" style={{ paddingTop: 15 }}>
              {isUserMapping &&
                <Button onClick={this.showSyncActiveOwnerInstructions}><Fa name="refresh" /> Sync Sales Reps</Button>
              }
              {isUserMapping && ' '}
              {isUserMapping && this.renderSyncModal()}
              {!loading && 
                <FilterButton 
                  filter={filter} 
                  onDelete={this.handleDelete} 
                  onSwitch={this.syncFilter}
                  onUpdate={this.handleFilterUpdate}
                >
                  <Fa name="edit" /> Edit Filter Group
                </FilterButton>
              }
              
            </div>
          </div>
        </div>
        <p />

        {loading && <ProgressBar />}
        {!loading && errors !== null && <div className="alert alert-danger">{errors.message}</div>}
        {!loading && errors === null && 
          <div>
            {this.renderDescription()}
            {this.renderTable()}
            <ImportMappingModal
              filter={filter}
              onClose={() => {
                this.setState({ currentMapping: null, openImportModal: false })
              }}
              isUserMapping={isUserMapping}
              open={openImportModal}
              onImport={this.handleImport}
            />
          </div>
        }
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { params: { filterID } } = ownProps.match;
  const filter = getFilter(state, filterID);

  const mappings = filter && filter.mappings ? filter.mappings || [] : [];
  const options = getMappingOptions(state);

  const mappingOptions = map(options, (m) => {
    const { value } = m;
    let checked = false;
    each(mappings, (mapping) => {
      if (!checked) {
        checked = indexOf(mapping.values, value) >= 0;
      }
    });
    return { ...m, excluded: !checked };
  });

  return {
    filter,
    filters: getFilters(state),
    searchableFields: getSearchableFields(state),
    viewableDimensions: getViewableDimensions(state),
    mappingOptions,
  };
}

FilterDetailPage.propTypes = {
  filter: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  searchableFields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  viewableDimensions: PropTypes.shape({}).isRequired,
  mappingOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

FilterDetailPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(FilterDetailPage);
